// Create some re-useable definitions because
// many input types are identical in how
// we want to style them.
const textClassification = {
    label: 'block mb-1 font-medium leading-relaxed',
    inner: `
    border
    border-gray-300
    rounded-md mb-1
    overflow-hidden
    focus-within:border-primary-500
    focus-within:ring-1 
    focus-within:ring-primary-500
  `,
    input: 'w-full min-w-[60px] min-h-[36px] px-3 border-none text-sm text-gray-700 placeholder-gray-400',
}
const boxClassification = {
    legend: 'font-bold text-sm',
    wrapper: 'flex items-center cursor-pointer',
    help: 'mb-2',
    options: 'mt-4 space-y-3',
    input: 'form-check-input appearance-none h-4 w-4 border border-gray-300 rounded-md-sm bg-white checked:bg-primary-500 focus:outline-hidden transition duration-200 focus:ring-primary-500',
    label: 'mt-0.5 ml-3 block text-sm font-medium text-gray-700',
}
const buttonClassification = {
    wrapper: 'mb-1',
    input: 'bg-primary-500 hover:bg-primary-700 text-white text-sm font-normal py-3 px-5 rounded-md',
}

// export our definitions using our above
// templates and declare one-offs and
// overrides as needed.
export default {
    // the global key will apply to all inputs
    global: {
        outer: 'formkit-disabled:opacity-50',
        help: 'mt-2 text-sm text-gray-500',
        messages: 'list-none p-0 mt-1 mb-0',
        message: 'text-red-700 mb-1 text-xs',
        label: 'block mb-1 font-medium leading-relaxed',
        input: 'focus:outline-0 focus-within:outline-0 focus:ring-0 focus-within:ring-0',
        prefixIcon:
            'pointer-events-none flex items-center pl-3 pr-0 [&_svg]:h-4 [&_svg]:w-4',
        // 'flex select-none shrink-0 grow-0 px-2 [&_svg]:h-4 [&_svg]:w-4 [&_svg]:m-auto [&_svg]:w-full',
        inner: 'flex relative items-center',
        dropdownWrapper:
            'shadow-lg focus:outline-hidden bg-white rounded-md my-2 mx-0',
        listbox:
            'bg-white border p-1 rounded-md left-0 m-0 list-none outline-hidden overflow-hidden hover:cursor-pointer',
        listitem:
            'relative flex font-normal rounded-md justify-between items-center py-2 px-3 data-is-active:bg-gray-100 aria-selected:flex-row-reverse aria-selected:bg-gray-100! aria-selected:font-medium',
    },
    button: buttonClassification,
    color: {
        label: 'block mb-1 font-bold leading-relaxed',
        input: 'w-16 h-8 appearance-none cursor-pointer border border-gray-300 rounded-md mb-2 p-1',
    },
    date: textClassification,
    'datetime-local': textClassification,
    checkbox: boxClassification,
    email: textClassification,
    autocomplete: {
        label: 'block mb-1 font-medium leading-relaxed',
        inner: `
    border
    border-gray-300
    rounded-md mb-1
    relative
    flex
    items-center
    focus-within:border-primary-500
    focus-within:ring-1 
    focus-within:ring-primary-500
    [&_.formkit-selection]:absolute
    [&_.formkit-selection]:left-0
    [&_.formkit-selection]:top-0
    [&_.formkit-selection]:right-0
    [&_.formkit-selection]:bottom-0
    [&_.formkit-selection]:mt-0
  `,
        input: 'w-full min-w-[60px] rounded-md min-h-[36px] px-3 border-none text-sm text-gray-700 focus:outline-0 focus-within:outline-0 focus:ring-0 focus-within:ring-0 placeholder-gray-400',
        selection:
            'bg-gray-100 py-2 px-3 flex border-none items-center mt-2 justify-between grow rounded-md text-gray-500 font-normal',
        option: 'grow',
        listboxButton:
            'appearance-none border-none bg-transparent self-stretch p-0 cursor-pointer flex',
        selectIcon:
            'w-10 grow-0 shrink-0 self-stretch select-none flex [&_svg]:max-h-4 [&_svg]:max-w-4 [&_svg]:w-full [&_svg]:m-auto',
        selectedIcon:
            'w-10 -mr-3 grow-0 shrink-0 self-stretch select-none flex [&_svg]:max-h-4 [&_svg]:max-w-4 [&_svg]:w-full [&_svg]:m-auto',
        removeSelection:
            '-mr-3 appearance-none border-none bg-transparent self-stretch p-0 cursor-pointer flex',
        closeIcon:
            'w-10 grow-0 shrink-0 self-stretch select-none flex [&_svg]:max-h-4 [&_svg]:max-w-4 [&_svg]:w-full [&_svg]:m-auto',
        loaderIcon:
            'animate-spin grow-0 shrink-0 self-stretch select-none flex [&_svg]:max-h-4 [&_svg]:max-w-4 [&_svg]:w-full [&_svg]:m-auto',
    },
    dropdown: {
        selector:
            'appearance-none text-left border-none bg-transparent p-0 flex items-center grow justify-between',
        selection: 'grow py-2 px-3',
        label: 'block mb-1 font-medium leading-relaxed',
        inner: `
    border
    border-gray-300
    rounded-md mb-1
    relative
    flex
    items-center
    focus-within:border-primary-500
    focus-within:ring-1 
    focus-within:ring-primary-500
  `,
        option: 'text-sm',
        placeholder: 'py-2 px-3 text-sm grow text-gray-400',
        selectIcon:
            'w-10 grow-0 shrink-0 self-stretch select-none flex [&_svg]:max-h-4 [&_svg]:max-w-4 [&_svg]:w-full [&_svg]:m-auto',
        selectedIcon:
            'w-10 -mr-3 grow-0 shrink-0 self-stretch select-none flex [&_svg]:max-h-4 [&_svg]:max-w-4 [&_svg]:w-full [&_svg]:m-auto',
    },
    taglist: {
        label: 'block mb-1 font-medium leading-relaxed',
        inner: `
    border
    border-gray-300
    rounded-md mb-1
    relative
    flex
    items-center
    focus-within:border-primary-500
    focus-within:ring-1 
    focus-within:ring-primary-500
  `,
        input: 'p-0 grow w-0 leading-7 border-none text-sm text-gray-700 focus:outline-0 focus-within:outline-0 focus:ring-0 focus-within:ring-0 placeholder-gray-400',
        selectIcon:
            'w-10 grow-0 shrink-0 self-stretch select-none flex [&_svg]:max-h-4 [&_svg]:max-w-4 [&_svg]:w-full [&_svg]:m-auto',
        selectedIcon:
            'w-10 grow-0 shrink-0 self-stretch select-none flex [&_svg]:max-h-4 [&_svg]:max-w-4 [&_svg]:w-full [&_svg]:m-auto',
        tags: 'flex gap-2 flex-wrap w-full px-2 py-1 items-center',
        tag: 'flex-none flex leading-none items-center text-xs text-primary-500 rounded-md pl-2 pr-1 py-1.5 bg-primary-50 outline-0 border-0',
        tagWrapper:
            'leading-none [&:focus_.formkit-tag]:bg-primary-500 [&:focus_.formkit-tag]:text-white!',
        closeIcon:
            'grow-0 shrink-0 self-stretch select-none flex [&_svg]:max-h-3 [&_svg]:max-w-3 [&_svg]:w-full [&_svg]:m-auto',
        removeSelection:
            'appearance-none border-none bg-transparent self-stretch p-0 px-1 cursor-pointer flex',
        // listitem: 'relative flex font-normal rounded-md justify-between items-center py-2 px-3 aria-selected:flex-row-reverse aria-selected:text-black aria-selected:font-semibold data-is-active:bg-gray-100',
    },
    toggle: {
        input: 'absolute w-0 h-0 opacity-0 [&:checked_~.formkit-track]:bg-primary-600 [&:checked_~.formkit-track_.formkit-thumb]:translate-x-full',
        track: 'relative w-10 h-5 rounded-md-full bg-gray-300',
        thumb: 'absolute w-4 h-4 rounded-md-full bg-white shadow-sm',
    },
    file: {
        label: 'block mb-1 font-bold leading-relaxed',
        inner: 'max-w-md cursor-pointer',
        input: 'text-gray-600 text-sm mb-1 file:mr-4 file:py-2 file:px-4 file:rounded-md-full file:border-0 file:text-sm file:bg-primary-500 file:text-white hover:file:bg-primary-600',
        noFiles: 'block text-gray-800 text-sm mb-1',
        fileItem: 'block flex text-gray-800 text-sm mb-1',
        fileRemove: 'ml-auto text-primary-500 text-sm',
    },
    month: textClassification,
    number: textClassification,
    password: textClassification,
    radio: {
        ...boxClassification,
        input: boxClassification.input.replace(
            'rounded-md-sm',
            'rounded-md-full'
        ),
    },
    range: {
        inner: 'max-w-md',
        input: 'form-range appearance-none w-full h-2 p-0 bg-gray-200 rounded-md-full focus:outline-hidden focus:ring-0 focus:shadow-none',
    },
    search: textClassification,
    select: textClassification,
    submit: buttonClassification,
    tel: textClassification,
    text: textClassification,
    textarea: {
        ...textClassification,
        input: 'block w-full h-32 px-3 border-none text-sm text-gray-700 placeholder-gray-400 focus:shadow-outline',
    },
    time: textClassification,
    url: textClassification,
    week: textClassification,
}
